
import { BASE_URL } from "../../config/axios";
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { formatDateTime, formattedDate, formattedDateLong } from '../Date';
import { handleErrorToast } from '../CustomFunctions'
import { useLocation, useNavigate } from 'react-router-dom'
import { fetchExistingLetterTemplate } from '../CustomUtilities';
import TemplateDisplayWrapper from "../DynamicBuilders/LetterDisplayComponents/TemplateDisplayWrapper";
import { LetterPreview } from "../DynamicBuilders/LetterDisplayComponents/LetterPreview";

const Letter1 = ({ letterid, lno, empcode }) => {
  const [subCompany, setSubCompany] = useState({});
  const [buffer, setBuffering] = useState(false);
  const [buffer1, setBuffering1] = useState(false);
  const [letterData, setLetterData] = useState({})
  const [personalData, setPersonalData] = useState({})
  const [letterTemplate, setLetterTemp] = useState({});
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const date = formattedDate

  const getLetterData = async () => {
    setBuffering(true)
    try {
      const res = await axios.get(`${BASE_URL}/wfm/incrementbyemployee/${empcode}/`);
      const ress = await axios.get(`${BASE_URL}/wfm/ourcompanydetailsbyemp/${empcode}/`);

      // setLetterData(res.data[lno])
      setLetterData(res.data.find((item) => item.id === letterid))
      setPersonalData(ress.data)

    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false)
    }
  };

  const loadLetterTemplate = async () => {
    setBuffering1(true);
    try {
      const { template, subcompany } = await fetchExistingLetterTemplate({
        subcompanyId: personalData?.division,
        letterTemplateId: letterData?.letter_template,
        emp_code: personalData?.emp_code,
      });

      if (template) setLetterTemp(template);
      if (subcompany) setSubCompany(subcompany);
    } catch (err) {
      // toast.warning("Could not fetch letter template");
    } finally {
      setBuffering1(false);
    }
  };


  useEffect(() => {
    loadLetterTemplate();
  }, [personalData?.subcompany, letterData?.letter_template, personalData?.emp_code])

  useEffect(() => {
    getLetterData();
  }, [empcode]);

  const contentData = (
    <>

      <p style={{ margin: '12px 0px 3px 0px' }}>
        <b>To,</b>
        <span style={{ float: 'right' }}>Date - {letterData?.upload_datetime ? formatDateTime(letterData?.upload_datetime).longdate : formattedDateLong(date)}</span>
      </p>

      <p style={{ margin: '3px 0px 20px 0px' }}>
        <b>{personalData?.name}</b>
      </p>

      {personalData?.emp_code && (
        <p style={{ margin: '12px 0px 3px 0px' }}>
          <b>Emp Code - </b>{personalData?.emp_code}
        </p>
      )}

      <p style={{ margin: '2px 0px 2px 0px' }}>
        <b>Department - </b>{personalData?.department_name}
      </p>

      <p style={{ margin: '2px 0px 2px 0px' }}>
        <b>Designation - </b>{letterData?.old_designation}
      </p>

      <p style={{ margin: '2px 0px 2px 0px' }}>
        <b>Grade – </b>{letterData?.previous_grade}
      </p>

      <p style={{ margin: '2px 0px 23px 0px' }}>
        <b>D.O.J. – </b>{formattedDateLong(personalData?.joining_date)}
      </p>

      <p style={{ margin: '12px 0px 23px 0px' }}>
        <b>Subject: </b>Increment Letter for yearly Performance review
      </p>

      <p>
        <b>Dear {personalData?.name},</b>
      </p>

      <p style={{ textAlign: "justify" }}>
        We congratulate you for your hard work, enthusiasm, dedication and continuous effort in meeting the organization objectives.
      </p>

      <p style={{ textAlign: "justify" }}>
        On reviewing your yearly performance.  We are glad to announce an increment of<b> Rs. {letterData?.increment_amount}/-</b> pm i.e. <b>{letterData?.increment_percentage}%</b> on your existing CTC Rs. {letterData?.existing_ctc}/- and now your revised CTC will be Rs. {letterData?.revised_ctc}/- with effect from   <b>{formattedDateLong(letterData?.wefdate)}</b>
      </p>

      <p style={{ textAlign: "justify" }}>
        We expect you to keep up your performance in the years to come and grow with the organization.
      </p>

      <p>
        Wish you all the best.
      </p>
    </>
  );

  const ref = useRef();
  const navigate = useNavigate()
  const currentUrl = window.location.href;
  const urlParts = currentUrl.split('/');
  const location = useLocation();
  const opener = location.state ? location.state.opener : "";
  const { emp_code, lettertype, index, opener: _opener, ...backState } = location.state || {};

  const filter_subCompany = location.state ? location.state.filter_subCompany : "";
  const filter_empstatus = location.state ? location.state.filter_empstatus : "";
  const filter_employee = location.state ? location.state.filter_employee : "";
  const filter_start_date = location.state ? location.state.filter_start_date : "";
  const filter_end_date = location.state ? location.state.filter_end_date : "";
  const filter_date_sorting = location.state ? location.state.filter_date_sorting : "";


  // const filter_subCompany = location.state ? location.state.filter_subCompany : "";
  // const filter_empstatus = location.state ? location.state.filter_empstatus : "";
  // const filter_employee = location.state ? location.state.filter_employee : "";
  // const filter_start_date = location.state ? location.state.filter_start_date : "";
  // const filter_end_date = location.state ? location.state.filter_end_date : "";
  // const filter_date_sorting = location.state ? location.state.filter_date_sorting : "";

  let backUrl = "/" + urlParts[3] + `/userdetail`;

  if (opener === "payroll") {
    backUrl = "/" + urlParts[3] + `/payrollmanagement`;
  }
  else if (opener === "adminuser") {
    backUrl = "/" + urlParts[3] + "/" + urlParts[4] + "/" + urlParts[5] + "/" + urlParts[6] + `/`;
  }
  else if (opener === "wfm") {
    backUrl = "/" + urlParts[3] + `/wfm`;
  }
  const toggleuser = 5;
  const togglepayroll = 8;
  // const backroute = () => {
  //   navigate(backUrl, {
  //     state: {
  //       toggleuser, togglepayroll,
  //       // filter_subCompany,
  //       // filter_empstatus,
  //       // filter_employee,
  //       // filter_start_date,
  //       // filter_end_date,
  //       // filter_date_sorting
  //     }
  //   })
  // }
  const backroute = () => {
    navigate(backUrl, {
      state: {
        ...backState,
        ...(opener === "wfm" ? { firsttoggle: 7 } : {}),
        toggleuser,
        togglepayroll,
        toggleState: 2,
        filter_subCompany,
        filter_empstatus,
        filter_employee,
        filter_start_date,
        filter_end_date,
        filter_date_sorting
      }
    })
  }

  return (

    <>
      <TemplateDisplayWrapper
        onBack={backroute}
        ref={ref}
        downloadEnable={false}
      >
      </TemplateDisplayWrapper >
      <LetterPreview
        letterTemplateData={letterTemplate}
        letterData={letterData}
        subCompany={subCompany}
        buffer1={buffer}
        buffer2={buffer1}
        ref={ref}
        lineHeight={1.5}
        // fontSize={16}
        showDefaultSignText={true}
      >
        {contentData}
      </LetterPreview>
    </>
  );
};


export default Letter1





